import { Blogs } from "../../../../../components/backgrounds/Blogs";

export function AumentarCupoPage() {
  return (
    <>
      <Blogs
        title={"¿Cómo aumentar mi cupo de crédito en Galilea?"}
        content={
          <>
            <div className="pt-6 opacity-60 text-xl">
              <p className="">
                ¿Te gustaría aumentar tu límite de crédito, pero aún no sabes
                cómo hacerlo? Hoy te contamos qué debes hacer para aumentar tu
                crédito en Galilea.
              </p>
            </div>
            <div className="pt-10 pb-10 opacity-60 text-xl">
              <p className="">
                El cupo de crédito es el valor total que Galilea le presta como
                entidad financiera a un nuevo astronauta que quiere ingresar a
                nuestro mundo Fintech. Para establecer este monto tenemos en
                cuenta un par de cosas, cuáles son tus hábitos de pago y cuál es
                tu capacidad de endeudamiento a partir de métricas rápidas y
                digitales.
              </p>
            </div>
            <span className="text-xl lg:text-2xl font-light">
              <a href="/registrarse" className="text-purple hover:underline">
                Si quieres solicitar tu crédito en Galilea da clic aquí.
              </a>
            </span>
            <div className="pt-10 opacity-60 text-xl">
              <p className="">
                Nosotros buscamos ser tus aliados, por eso siempre estamos
                pensando en ti y en tu bienestar financiero, queremos ser los
                que te brindan una mano cuando más lo necesitas, pero también
                tenemos en cuenta a la hora de escoger el cupo de crédito de
                nuestros usuarios no darles préstamos que se puedan volver
                agobiantes en el futuro.
              </p>
              <p className="pt-10">
                No obstante, en ocasiones esa capacidad crediticia que se logra
                aprobar no es suficiente para brindar un respaldo tan amplio
                como te gustaría. Esto nos lleva a la pregunta:
              </p>
            </div>
            <div className="pt-10">
              <span className="text-2xl lg:text-4xl">
                ¿Cómo aumentar mi cupo de crédito?
              </span>
            </div>
            <div className="pt-10 opacity-60 text-xl">
              <p className="">
                Si tu misión es aumentar ese cupo te recomendamos que pagues de
                manera puntual, preferiblemente antes de la fecha de pago y
                demostrar que pagas tu crédito actual sin problemas. También
                puedes aumentar tu nivel de ingresos, de tal manera que Galilea
                pueda comprobar gracias a los datos que recolecta con tu previa
                autorización y en las bases de datos oficiales que efectivamente
                tus ingresos han aumentado, esto se verá reflejado en un
                incremento de tu cupo de crédito.
              </p>
            </div>
            <div className="pt-10">
              <span className="text-2xl lg:text-4xl">Recomendación</span>
            </div>
            <div className="pt-10 opacity-60 text-xl">
              <p className="">
                Lo más importante es que tengas paciencia, una buena relación
                financiera se construye con el paso del tiempo, poco a poco
                iremos recopilando información sobre tu perfil de gasto vs
                ingreso y así podrás tener un límite crediticio más cercano a
                tus necesidades, no te estreses.
              </p>
            </div>
          </>
        }
        enlace1={
          <a href="/blog/como-mejorar-mi-puntaje-en-datacredito" className="text-purple hover:underline">
            ¿Cómo mejorar mi puntaje de crédito?
          </a>
        }
        enlace2={
          <a
            href="/blog/6-consejos-para-manejar-tus-finanzas"
            className="text-purple hover:underline"
          >
            6 consejos para manejar tus finanzas personales
          </a>
        }
        enlace3={
          <a
            href="/blog/4-apps-para-llevar-un-registro-financiero"
            className="text-purple hover:underline"
          >
            Apps para controlar tus finanzas personales
          </a>
        }
      />
    </>
  );
}
